/* C-05 Day header and date flag. */
.flag {
  display: inline-block;
  padding: 2px 6px;
  background: var(--color-surface-inverse);
  color: var(--color-text-on-inverse);
}
.today {
  background: var(--color-surface-signal);
  color: var(--color-text-on-signal);
}
.header {
  display: grid;
  gap: var(--dimension-space-2);
  margin: 0;
}
.row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--dimension-space-2);
}
.muted {
  color: var(--color-text-secondary);
}
.total {
  margin-left: auto;
}
.rule {
  height: var(--dimension-line-stripe);
}
